import request from './index'

// 用户登录
export function login(data) {
	
	return request({
		url: '/auth/weChatLogin',
		method: 'post',
		data
	})
}

// 用户注册
export function register(data) {
	return request({
		url: '/user/register',
		method: 'post',
		data
	})
}

// 获取用户信息
export function getUserInfo() {
	return request({
		url: '/muser/app/user/getMyDetailByToken',
		method: 'get'
	})
}



// 退出登录
export function logout() {
	return request({
		url: '/auth/logout',
		method: 'post'
	})
}




// 获取验证码
export function getCodeImg() {
	return request({
		url: '/auth/code',
		method: 'get'
	})
}